import { getGridSummaryCount, renderGridSummarySum, renderGridSummarySumHL } from 'components/global/utils';
import { RedatedGridData } from '@pages/reporting-pages/redated-orders/types/RedatedGridData';



interface GridSummaryProps<T> {
	data?: T[] | null,
}


const GridSummary = (props: GridSummaryProps<RedatedGridData>) => {
	const { data } = props;

	return (
		<>
			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{getGridSummaryCount(data)}</p>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySumHL(data, 'orderSentVolume', 2)}</p>
			</div>

			<div className='app-grid-summary'>
				<p>{renderGridSummarySum(data, 'orderSentCount')}</p>
			</div>
		</>
	)
}

export default GridSummary;